import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-sheet_icon-06",
  "use": "icon-sheet_icon-06-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-sheet_icon-06\"><g transform=\"translate(-267 -217)\" stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><rect x=\"270.75\" y=\"219.75\" width=\"16.5\" height=\"18.5\" rx=\"2\" /><path d=\"M270.877 224h16.144\" /><path stroke-linecap=\"round\" d=\"M274.559 238v-5.5M279 238v-7.95M283.559 238v-11\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol